export const CONF_DOMAIN = "conf/";
export const NEW_FACILITY_IDS = CONF_DOMAIN + "/newFacilityIds";
export const GET_CONFIGURATION_FACILITY = CONF_DOMAIN + "/getConfigurationFacility";